import React from 'react';
import { AlertTriangle, FileText, Bell, FilePlus } from 'lucide-react';

const ClientWarningCard = ({ warning }) => {
  if (!warning || !warning.hasWarnings) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
      <div className="flex items-start">
        <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-yellow-800 mb-2">
            Atenție: {warning.clientName}
          </h4>
          
          <div className="space-y-2 text-sm text-yellow-700">
            {warning.hasActiveContracts && (
              <div className="flex items-center">
                <FileText className="h-4 w-4 mr-2" />
                <span>
                  {warning.activeContractsCount} contract{warning.activeContractsCount > 1 ? 'e' : ''} activ{warning.activeContractsCount > 1 ? 'e' : ''}
                </span>
              </div>
            )}

            {warning.hasPendingNotices && (
              <div className="flex items-center">
                <Bell className="h-4 w-4 mr-2" />
                <span>
                  {warning.pendingNoticesCount} notificar{warning.pendingNoticesCount > 1 ? 'i' : 'e'} de reziliere pending
                </span>
              </div>
            )}

            {warning.hasRecentAdditionalActs && (
              <div className="flex items-center">
                <FilePlus className="h-4 w-4 mr-2" />
                <span>
                  {warning.recentAdditionalActsCount} act{warning.recentAdditionalActsCount > 1 ? 'e' : ''} adițional{warning.recentAdditionalActsCount > 1 ? 'e' : ''} recent{warning.recentAdditionalActsCount > 1 ? 'e' : ''}
                </span>
              </div>
            )}
          </div>

          {/* Detailed information */}
          {warning.activeContracts && warning.activeContracts.length > 0 && (
            <div className="mt-3 pt-3 border-t border-yellow-200">
              <p className="text-xs font-medium text-yellow-800 mb-2">Contracte active:</p>
              <ul className="text-xs text-yellow-700 space-y-1">
                {warning.activeContracts.map((contract) => (
                  <li key={contract.id} className="flex justify-between">
                    <span>{contract.number}</span>
                    <span className="font-medium">
                      Expiră în {contract.daysUntilExpiry} zile
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientWarningCard;